<template>
    <div class="container"> 
        <div class="logos">
           <router-link to="/">
            <img src="/risecolor.png" alt="">
            </router-link>
        </div>
        <div class="logout">
  <div class="botao">
    <button @click="handleClick">{{ buttonText }}</button>
  </div>        </div>
    </div>
</template>

<style lang="scss" scoped>
@import '@/assets/scss/style.scss';
.container{
    display: flex;
    justify-items: center;
    align-items: center;
   
    justify-content: space-between;
   
}
 .logos{
    width: 14%;
    cursor: pointer;
 }
 .logos img{
    width: 70%;
 }
 .logout{
    width: 10%;
 }
</style>


<script setup>
const props = defineProps({
  buttonText: { type: String, default: 'Clique aqui' },
  redirectRoute: { type: String, default: '' }
})

const emit = defineEmits(['click']) // Caso queira emitir evento personalizado

function handleClick() {
  // Emite o clique para o componente pai
  emit('click')

  // Se quiser redirecionar com base na prop (opcional)
  if (props.redirectRoute) {
    window.location.href = props.redirectRoute // ou use Vue Router
  }
}
</script>

<style scoped>
.botao {
  height: 30px;
}

button {
  background-color: #002f73;
  color: white;
  border: none;
  width: 100%;
  padding: 5%;
  border-radius: 5px;
  cursor: pointer;
  font-weight: bold;
}
</style>
